import React, { useState } from 'react';
import logo from '../assets/Logo-Dre-Global.png'; // Ajusta la ruta según tu proyecto


const LoginForm = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await fetch('backend/auth.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ username, password })
      });
      const result = await response.json();
      if (result.success) {
        onLogin(result.user);
      } else {
        setError(result.error || 'Error al iniciar sesión');
      }
    } catch (err) {
      console.error('Error:', err);
      setError('Error al conectar con el servidor');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded shadow-md w-full max-w-md">
      <img src={logo} alt="DRE Logo" className="w-32 mx-auto mb-4" />
        <h2 className="text-2xl font-semibold mb-4 text-center">Iniciar Sesión</h2>
        {error && <p className="text-red-600 mb-2 text-sm">{error}</p>}
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Usuario</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#31a749] focus:border-[#31a749]"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#31a749] focus:border-[#31a749]"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-[#31a749] text-white py-2 px-4 rounded-md hover:bg-[#31a749] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#31a749]"
          >
            Iniciar Sesión
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
